import bigWinTitleDe from '../../../../../assets/big-win-title-de.png';
import bigWinTitle from '../../../../../assets/big-win-title.png';
import { SupportedLanguages } from '../../../../../i18n/constants';
import { getUserLanguage } from '../../../../../i18n/helpers';

export const getBigWinTitle = (language: SupportedLanguages = getUserLanguage()): string => {
  switch (language) {
    case SupportedLanguages.DE:
      return bigWinTitleDe;
    default:
      return bigWinTitle;
  }
};
